export interface EquipementItems {
    id: number;
    libelle: string;
    phaseId: number;
    phaseLibelle: string;
    groupeId: number;
    groupeLibelle: string;
    sousGroupeId: number;
    sousGroupeLibelle: string;
    adresseProjetId: number;
}

function equipementToString(equipement: EquipementItems): string {
    if (equipement){
        let phase = '';
        if(equipement.phaseLibelle && equipement.phaseLibelle.trim().toLowerCase() !== 'maintenance') {
            phase = equipement.phaseLibelle + ' ';
        }

        if(equipement.sousGroupeLibelle) {
            return (equipement.groupeLibelle + ' > ' + equipement.sousGroupeLibelle + ' > ' + phase + '[' + equipement.libelle + ']');
        }
        return equipement.groupeLibelle + ' > ' + phase + '[' + equipement.libelle + ']';
    }
    return '';
}


export function equipementsToString(equipements: EquipementItems[]): string {
    let equipementStr = '';
    if(equipements){
        equipements.forEach(e => { equipementStr = equipementStr + equipementToString(e) + '\n'; });
    }
    return equipementStr;
}
